module.exports = __webpack_public_path__ + "static/media/icon-erase-red.a3d27e42.svg";